<template>
  <UserShell
    title="主播管理"
    subtitle="管理机构旗下签约主播信息"
    :profile="profile"
    :menu-items="menuItems"
    active-key="talent"
    center-path="/user/org"
  >
    <div class="toolbar">
      <div class="search-group">
        <el-input v-model.trim="keyword" placeholder="请输入主播姓名/手机号" class="search-input" @keyup.enter.native="handleSearch" />
        <button type="button" class="search-btn" @click="handleSearch">
			  <img src="../../assets/img/user/ss.png"/>
			搜索
		</button>
      </div>

      <div class="toolbar-actions">
        <button type="button" class="ghost-btn" @click="openBatchDialog">批量增加主播</button>
        <button type="button" class="primary-btn" @click="goTalentForm()">+ 增加主播</button>
      </div>
    </div>

    <div class="table-wrap">
      <table class="talent-table">
        <thead>
          <tr>
            <th>平台ID</th>
            <th>姓名</th>
            <th>垂类赛道</th>
            <th>全网粉丝数</th>
            <th>平台数量</th>
            <th>近一年利润</th>
            <th>授权状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in talents" :key="item.id">
            <td>{{ item.platformCode }}</td>
            <td class="name-cell">{{ item.name }}</td>
            <td>{{ item.category }}</td>
            <td>{{ item.totalFans }}</td>
            <td>{{ item.platformCount }}</td>
            <td>{{ item.annualProfit }}</td>
            <td :class="item.authStatus === '授权到期' ? 'expired-text' : 'authorized-text'">{{ item.authStatus }}</td>
            <td>
              <div class="action-group">
                <button type="button" class="table-btn view" @click="goTalentForm(item.id)">编辑</button>
                <button type="button" class="table-btn remove" @click="removeTalent(item.id)">删除</button>
              </div>
            </td>
          </tr>
          <tr v-if="!talents.length">
            <td colspan="8" class="empty-cell">暂无主播信息</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="total > perPage" class="pagination-row">
      <el-pagination
        background
        layout="prev, pager, next, jumper"
        :current-page="page"
        :page-size="perPage"
        :total="total"
        @current-change="handlePageChange"
      />
    </div>
    <el-dialog :visible.sync="batchDialogVisible" :show-close="false" width="760px" custom-class="batch-dialog" append-to-body @close="resetBatchUpload">
      <div class="batch-body">
        <div class="batch-head">
          <div>
            <h3>批量增加主播</h3>
            <p>请下载模板后，根据模板内容填写各主播真实信息并以主播名字命名文件</p>
          </div>
          <button type="button" class="template-btn" @click="downloadTemplate">信息表模板</button>
        </div>

        <div class="batch-upload-row">
          <span class="upload-field">主播信息表：</span>
          <button type="button" class="upload-btn" :disabled="uploadedBatchFiles.length >= 30" @click="triggerBatchUpload">上传文件</button>
          <input ref="batchUploader" type="file" class="hidden-input" multiple accept=".docx" @change="handleBatchUpload" />
          <!-- <span class="upload-count">已上传 {{ uploadedBatchFiles.length }}/30</span> -->
        </div>
        <div class="batch-tip">格式要求word，不超过10M；可同时上传最多30位主播信息表，支持多次选择追加</div>

        <div class="preview-list">
          <div v-for="(item, index) in uploadedBatchFiles" :key="item.name + index" class="preview-card">
            <div class="preview-doc">
              <button type="button" class="preview-remove" @click="removeBatchFile(index)">×</button>
            </div>
            <div class="preview-name" :title="item.name">{{ item.name }}</div>
          </div>
        </div>

        <div class="batch-actions">
          <button type="button" class="dialog-btn ghost" @click="closeBatchDialog">取消</button>
          <button type="button" class="dialog-btn primary" :disabled="batchSubmitting" @click="submitBatch">{{ batchSubmitting ? '提交中...' : '立即提交' }}</button>
        </div>
      </div>
    </el-dialog>
  </UserShell>
</template>

<script>
import UserShell from './components/UserShell.vue';
import sidebarBg from '@/assets/img/user/背景卡图.png';
import userAvatar from '@/assets/img/user/avatar.png';
import overviewActiveIcon from '@/assets/img/user/griconxz.png';
import overviewActiveIconIn from '@/assets/img/user/gricon.png';
import talentActiveIcon from '@/assets/img/user/zbglxz.png';
import talentInactiveIcon from '@/assets/img/user/zbgl.png';
import assetActiveIcon from '@/assets/img/user/申请icon.png';
import assetInactiveIcon from '@/assets/img/user/申请未选中.png';
import {
  batchCreateStreamerProfiles,
  deleteStreamerProfile,
  getMemberProfile,
  getStreamerProfileList
} from '@/api/user';

const MAX_BATCH_FILES = 30;
const MAX_FILE_SIZE = 10 * 1024 * 1024;
const TRACK_LABEL_MAP = {
  beauty_care: '美妆护肤',
  fashion_apparel: '服饰穿搭',
  food_beverage: '食品饮料',
  digital: '3C数码',
  mother_baby: '母婴亲子',
  home_living: '家居生活',
  maternity_child: '母婴育儿',
  education: '教育知识',
  sports_outdoors: '运动户外',
  gaming: '游戏电竞',
};

function createMenu() {
  return [
    { key: 'overview', label: '首页概览', path: '/user/org', activeIcon: overviewActiveIcon,inactiveIcon: overviewActiveIconIn},
    { key: 'talent', label: '主播管理', path: '/user/org/talents', activeIcon: talentActiveIcon, inactiveIcon: talentInactiveIcon },
    { key: 'asset', label: '资产评估申请', path: '/user/org/assets', activeIcon: assetActiveIcon, inactiveIcon: assetInactiveIcon }
  ];
}

function extractResponseData(response) {
  if (!response || typeof response !== 'object') {
    return {};
  }

  if (Array.isArray(response.data) && response.meta) {
    return response;
  }

  if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
    return response.data;
  }

  return response;
}

function normalizeTalentItem(item) {
  const source = item && typeof item === 'object' ? item : {};
  const platformAccounts = Array.isArray(source.platform_accounts) ? source.platform_accounts : [];
  const platformCount = source.platform_count != null ? source.platform_count : platformAccounts.length;

  return {
    id: source.id,
    platformCode: source.account_no || '--',
    name: source.name || '--',
    category: source.streamer_type_text || source.streamer_type || TRACK_LABEL_MAP[source.streamer_type] || '--',
    totalFans: source.total_fans || '--',
    platformCount: platformCount || 0,
    annualProfit: source.last_year_profit || '--',
    authStatus: source.authorization_status_text || '--',
    mobile: source.phone || ''
  };
}

function extractBatchImportResult(response) {
  if (!response || typeof response !== 'object') {
    return { success: [], failures: [] };
  }

  const payload = response.data && typeof response.data === 'object' && !Array.isArray(response.data)
    ? response.data
    : response;

  return {
    success: Array.isArray(payload.success) ? payload.success : [],
    failures: Array.isArray(payload.failures) ? payload.failures : []
  };
}

export default {
  name: 'OrganizationTalent',
  components: { UserShell },
  data() {
    return {
      profile: {
        name: '星辰传媒有限公司',
        role: 'MCN机构',
        avatar: userAvatar,
        background: sidebarBg
      },
      menuItems: createMenu(),
      keyword: '',
      searchKeyword: '',
      talents: [],
      page: 1,
      perPage: 15,
      total: 0,
      batchDialogVisible: false,
      uploadedBatchFiles: [],
      batchSubmitting: false
    };
  },
  created() {
    this.fetchPageData();
  },
  methods: {
    async fetchPageData() {
      await Promise.all([
        this.fetchProfile(),
        this.loadTalents()
      ]);
    },
    async fetchProfile() {
      try {
        const profileResponse = await getMemberProfile();
        const profileData = extractResponseData(profileResponse);
        this.profile = {
          ...this.profile,
          name: profileData.name || this.profile.name,
          role: profileData.type_text || this.profile.role,
          avatar: profileData.avatar || this.profile.avatar
        };
      } catch (error) {
        void error;
      }
    },
    async loadTalents() {
      try {
        const response = await getStreamerProfileList({
          keyword: this.searchKeyword || undefined,
          page: this.page,
          per_page: this.perPage
        });
        const payload = extractResponseData(response);
        const rows = Array.isArray(payload.data) ? payload.data : [];
        const meta = payload.meta && typeof payload.meta === 'object' ? payload.meta : {};

        this.talents = rows.map(normalizeTalentItem);
        this.total = Number(meta.total) || rows.length;
        this.page = Number(meta.current_page) || this.page;
        this.perPage = Number(meta.per_page) || this.perPage;
      } catch (error) {
        this.talents = [];
        this.total = 0;
        this.$message.error(error && error.message ? error.message : '获取主播列表失败');
      }
    },
    handleSearch() {
      this.searchKeyword = this.keyword;
      this.page = 1;
      this.loadTalents();
    },
    handlePageChange(nextPage) {
      this.page = nextPage;
      this.loadTalents();
    },
    goTalentForm(id) {
      const query = id ? { id: String(id) } : {};
      this.$router.push({ path: '/user/org/talents/form', query });
    },
    async removeTalent(id) {
      try {
        await this.$confirm('删除后不可恢复，确认删除该主播吗？', '提示', {
          type: 'warning'
        });
      } catch (error) {
        return;
      }

      try {
        await deleteStreamerProfile(id);
        this.$message.success('主播已删除');

        if (this.talents.length === 1 && this.page > 1) {
          this.page -= 1;
        }

        await this.loadTalents();
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '删除主播失败');
      }
    },
    openBatchDialog() {
      this.resetBatchUpload();
      this.batchDialogVisible = true;
    },
    closeBatchDialog() {
      this.batchDialogVisible = false;
      this.resetBatchUpload();
    },
    resetBatchUpload() {
      this.uploadedBatchFiles = [];
      if (this.$refs.batchUploader) {
        this.$refs.batchUploader.value = '';
      }
    },
    triggerBatchUpload() {
      if (this.uploadedBatchFiles.length >= MAX_BATCH_FILES) {
        this.$message.warning(`最多只能上传${MAX_BATCH_FILES}个主播信息表`);
        return;
      }
      this.$refs.batchUploader.click();
    },
    handleBatchUpload(event) {
      const files = Array.from(event.target.files || []);
      event.target.value = '';

      if (!files.length) {
        return;
      }

      const invalidType = files.some(file => !/\.docx$/i.test(file.name || ''));
      if (invalidType) {
        this.$message.warning('仅支持上传 .docx 格式文件');
        return;
      }

      const invalidSize = files.some(file => file.size > MAX_FILE_SIZE);
      if (invalidSize) {
        this.$message.warning('单个文件大小不能超过10M');
        return;
      }

      const remain = MAX_BATCH_FILES - this.uploadedBatchFiles.length;
      if (remain <= 0) {
        this.$message.warning(`最多只能上传${MAX_BATCH_FILES}个主播信息表`);
        return;
      }

      if (files.length > remain) {
        this.$message.warning(`最多只能上传${MAX_BATCH_FILES}个主播信息表，本次仅添加${remain}个`);
      }

      const existingNames = new Set(this.uploadedBatchFiles.map(item => item.name));
      const nextFiles = [];

      files.slice(0, remain).forEach(file => {
        if (existingNames.has(file.name)) {
          return;
        }
        existingNames.add(file.name);
        nextFiles.push({ name: file.name, file });
      });

      if (!nextFiles.length) {
        this.$message.warning('所选文件已存在或无可添加文件');
        return;
      }

      this.uploadedBatchFiles = this.uploadedBatchFiles.concat(nextFiles);
    },
    removeBatchFile(index) {
      this.uploadedBatchFiles.splice(index, 1);
    },
    downloadTemplate() {
      const fileName = '主播信息登记表.docx';
      const fileUrl = encodeURI(`/img/${fileName}`);
      fetch(fileUrl)
        .then(res => {
          if (!res.ok) {
            throw new Error('download failed');
          }
          return res.blob();
        })
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.$message.error('模板下载失败，请稍后重试');
        });
    },
    async submitBatch() {
      if (!this.uploadedBatchFiles.length) {
        this.$message.warning('请先上传主播信息表');
        return;
      }

      this.batchSubmitting = true;
      try {
        const response = await batchCreateStreamerProfiles(this.uploadedBatchFiles.map(item => item.file));
        const result = extractBatchImportResult(response);

        if (result.failures.length) {
          const message = result.failures
            .map(item => {
              const filename = item && item.filename ? item.filename : '未知文件';
              const reason = item && item.message ? item.message : '导入失败';
              return `<p style="margin: 0 0 8px;">${filename}：${reason}</p>`;
            })
            .join('');

          await this.$alert(message, '批量导入失败', {
            customClass: 'batch-alert-dialog',
            dangerouslyUseHTMLString: true,
            confirmButtonText: '知道了'
          });

          if (!result.success.length) {
            return;
          }

          this.$message.warning(`部分导入成功，成功 ${result.success.length} 个，失败 ${result.failures.length} 个`);
        } else {
          this.$message.success(`批量导入已提交，共 ${this.uploadedBatchFiles.length} 个文件`);
        }

        this.batchDialogVisible = false;
        this.resetBatchUpload();
        this.page = 1;
        await this.loadTalents();
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '批量导入失败');
      } finally {
        this.batchSubmitting = false;
      }
    }
  },
  watch: {
    '$route.fullPath'() {
      this.fetchPageData();
    }
  }
};
</script>

<style lang="scss" scoped>
	
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 28px;
}

.search-group,
.toolbar-actions,
.action-group {
  display: flex;
  align-items: center;
  gap: 14px;
}

.search-input {
  width: 256px;
}

.search-input ::v-deep .el-input__inner {
  border: 0;
  width: 256px;
  height: 32px;
  background: #F7F8FA;
}

.search-btn,
.ghost-btn,
.primary-btn,
.template-btn,
.upload-btn,
.dialog-btn,
.table-btn {
  border: 0;
  border-radius: 8px;
  cursor: pointer;
}

.search-btn,
.ghost-btn,
.primary-btn,
.upload-btn,
.dialog-btn.primary {
  background: #6f68f3;
  color: #fff;
  font-size: 14px;
}

.search-btn {
  width: 82px;
  height: 32px;
  background: #6F68F3;
  border-radius: 6px 6px 6px 6px;
  display: flex;
      align-items: center;
      justify-content: center;
}
.search-btn img{
	margin-right: 6px;
}

.ghost-btn{
	width: 112px;
	height: 36px;
	background: linear-gradient( 117deg, #7C83FF 0%, #8B44F4 100%);
	border-radius: 10px 10px 10px 10px;
}
.primary-btn {
  width: 104px;
  height: 36px;
  background: linear-gradient( 117deg, #7C83FF 0%, #8B44F4 100%);
  border-radius: 10px 10px 10px 10px;
}

.table-wrap {
  margin-top: 20px;
  border: 1px solid #d6d7d9;
  border-radius: 14px;
  overflow: hidden;
}

.pagination-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.talent-table {
  width: 100%;
  border-collapse: collapse;
}

.talent-table th,
.talent-table td {
  height: 54px;
  padding: 0 10px;
  border-bottom: 1px solid #d6d7d9;
  text-align: center;
  font-size: 14px;
  color: #1E293B;
}

.talent-table thead tr {
  background: #F8FAFC;
  height: 45px;
}

.talent-table th {
  height: 45px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 15px;
  color: #64748B;
  line-height: 20px;
}

.talent-table tbody tr:last-child td {
  border-bottom: 0;
}

.name-cell {
  color: #5f66ec !important
}

.authorized-text {
  color: #5f66ec !important;
}

.expired-text {
  color: #ED2D2D !important;
}

.table-btn {
  min-width: 62px;
  height: 32px;
  font-size: 14px;
}

.table-btn.view {
  color: #2564F6;
  font-size: 13px;
  width: 58px;
  height: 31px;
  background: #E6F2FF;
  border-radius: 6px 6px 6px 6px;
}

.table-btn.remove {
  color: #696E83;
  font-size: 13px;
  width: 58px;
  height: 31px;
  background: #EBECEE;
  border-radius: 6px 6px 6px 6px;
}

.empty-cell {
  color: #98a2b3;
}

.hidden-input {
  display: none;
}

.batch-body {
  padding: 6px 8px 0;
}

.batch-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.batch-head h3 {
  margin: 0;
  color: #303749;
  font-size: 20px;
}

.batch-head p{
	margin-top: 12px;
	font-weight: 400;
	font-size: 13px;
	color: #999FB8;
	line-height: 19px;
	text-align: left;
}
.batch-tip {
  margin-top: 8px;
  font-weight: 400;
  font-size: 12px;
  color: #999FB8;
  text-align: left;
  margin-left: 108px;
}

.template-btn {
  min-width: 120px;
  height: 36px;
  background: #eef4ff;
  color: #4f74ff;
}

.batch-upload-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 34px;
}

.upload-field {
  color: #1e293b;
  font-size: 16px;
}

.upload-btn {
  width: 98px;
  height: 34px;
}

.upload-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.upload-count {
  font-size: 13px;
  color: #999FB8;
}

.preview-list {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 16px;
  min-height: 88px;
  margin-left: 108px;
}

.preview-card {
  width: 72px;
  text-align: center;
  position: relative;
}

.preview-doc {
  height: 72px;
  border-radius: 8px;
  background: linear-gradient(180deg, #f6f8fd 0%, #e7ecfa 100%);
  border: 1px solid #d8dfef;
  position: relative;
}

.preview-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border: 0;
  border-radius: 50%;
  background: #999fb8;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
  padding: 0;
}

.preview-name {
  margin-top: 8px;
  color: #9ba3bd;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.batch-actions {
  display: flex;
  justify-content: center;
  gap: 28px;
  margin-top: 240px;
}

.dialog-btn {
  min-width: 120px;
  height: 40px;
}

.dialog-btn.primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.dialog-btn.ghost {
  border: 1px solid #d8dfef;
  background: #fff;
  color: #646b80;
}

.talent-table td{
	font-weight: 400;
	font-size: 14px;
	color: #1E293B;
}

::v-deep .el-dialog__body{
		padding: 0px 32px;
    padding-bottom: 37px;
	}

@media (max-width: 760px) {
  .toolbar,
  .search-group,
  .toolbar-actions,
  .batch-head,
  .batch-upload-row,
  .batch-actions {
    flex-direction: column;
    align-items: flex-start;
  }

  .table-wrap {
    overflow-x: auto;
  }

  .talent-table {
    min-width: 920px;
  }
}
</style>

<style lang="scss">
.batch-alert-dialog .el-button--primary,
.batch-alert-dialog .el-button--primary:hover,
.batch-alert-dialog .el-button--primary:focus,
.batch-alert-dialog .el-button--primary:active,
.batch-alert-dialog .el-button--small,
.batch-alert-dialog .el-button--small:hover,
.batch-alert-dialog .el-button--small:focus,
.batch-alert-dialog .el-button--small:active {
  background-color: #6f68f3 !important;
  border-color: #6f68f3 !important;
}

.batch-alert-dialog .el-button--primary span,
.batch-alert-dialog .el-button--small span {
  color: #fff !important;
}
</style>
